import { useEffect } from 'react';
import dayjs from 'dayjs';

import { SessionStorageManager, SiteConfigManager } from '@atlas/core';

import { POPUP_SIGN_UP_DELAY_STORAGE_KEYS } from 'common/constants';

export const useSetNextShowPopupSignUpDelay = () => {
  useEffect(() => {
    const enableSignUpDelay = SiteConfigManager.getConfig(
      'config.config.registration.mobile_popup',
    );

    if (enableSignUpDelay) {
      const nextDayMs = dayjs().add(1, 'd').valueOf();
      SessionStorageManager.setItem(POPUP_SIGN_UP_DELAY_STORAGE_KEYS.NEXT_SHOW, nextDayMs);
    }
  }, []);
};
